import React, { useState } from 'react';
import 'rsuite/dist/styles/rsuite-default.css';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Nav,
  Icon,
  Uploader
} from 'rsuite';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    direction: 'rtl',
    overflow: 'auto',
    height: '100%'
  },
  navBody: {
    width: 400,
    minHeight: '100%',
    direction: 'ltr',
    paddingLeft: 20,
    paddingBottom: 20
  },
  icon: {
    fontSize: '24px',
    color: '#1675e0'
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#1675e0'
  },
  btnContainer: {
    display: 'flex',
    padding: '15px 10px',
    justifyContent: 'flex-start'
  },
  uploaderBtn: {
    display: 'flex',
    marginRight: '10px',

    '& .rs-uploader-trigger button': {
      backgroundColor: '#3498ff !important',
      color: 'white !important',
      paddingLeft: '15px',
      paddingRight: '15px',

      '&:hover': {
        color: 'white !important'
      }
    },

    '& .rs-uploader-file-items': {
      display: 'none'
    }
  },
  removeBtn: {
    display: 'flex',
    height: '24px',
    width: '24px',
    borderRadius: '12px',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '5px',

    '&:hover': {
      backgroundColor: '#A6A6A6',
      color: 'white'
    }
  },
  item: {
    '& a': {
      display: 'flex !important',
      alignItems: 'center',
      width: '100%'
    }
  },
  itemName: {
    margin: 0,
    width: '325px !important',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  closeIn: {
    animationName: '$closeIn',
    animationDuration: '0.5s',
    animationTimingFunction: 'ease'
  },
  closeOut: {
    animationName: '$closeOut',
    animationDuration: '0.5s',
    animationTimingFunction: 'ease',
    animationFillMode: 'forwards'
  },
  '@keyframes closeIn': {
    from: {
      marginLeft: '-20px',
      opacity: 0
    }
  },
  '@keyframes closeOut': {
    to: {
      marginLeft: '-20px',
      opacity: 0,
      pointerEvents: 'none'
    }
  }
}));

const DocsNav = ({
  files = [],
  onFilesChange = (files) => {},
  activeFile = null,
  onActiveFileChange = (file) => {}
}) => {
  const classes = useStyles();

  const [showRemove, setShowRemove] = useState(false);
  const [justUploaded, setJustUploaded] = useState(true);

  const handleChange = (files) => {
    onFilesChange(files);
    setJustUploaded(true);
  };
  const handleSelect = (index) => {
    onActiveFileChange(files[index] || null);
  };
  const toggleShowRemove = () => {
    setShowRemove(!showRemove);
    setJustUploaded(!showRemove);
  };
  const removeFile = (e, index) => {
    e.stopPropagation();
    const file = files[index];
    const newFiles = [...files];
    newFiles.splice(index, 1);
    onFilesChange(newFiles);
    if (file === activeFile) {
      onActiveFileChange(null);
    }
  };

  const activeKey = (() => {
    for (let i = 0; i < files.length; i++) {
      if (files[i] === activeFile) {
        return i;
      }
    }
    return null;
  })();

  return (
    <div className={classes.wrapper}>
      <Nav
        className={classes.navBody}
        activeKey={activeKey}
        onSelect={handleSelect}
        vertical={true}
        appearance="tabs"
      >
        <Nav.Item
          style={{ pointerEvents: 'none' }}
          icon={<Icon className={classes.icon} icon="file-text" />}
        >
          <span className={classes.title}>Document Files</span>
        </Nav.Item>

        <li className={classes.btnContainer}>
          {!showRemove && (
            <Uploader
              className={classes.uploaderBtn}
              fileList={files}
              onChange={handleChange}
              autoUpload={false}
              multiple={true}
              accept={'.docx, .doc'}
            />
          )}

          {(!!(files || []).length || showRemove) && (
            <Button appearance="ghost" onClick={toggleShowRemove}>
              {showRemove ? 'Done' : 'Remove'}
            </Button>
          )}
        </li>

        {files.map((f, i) => (
          <Nav.Item
            key={i}
            eventKey={i}
            className={classes.item}
          >

            {showRemove && (
              <div
                onClick={(e) => removeFile(e, i)}
                className={`${classes.removeBtn} ${classes.closeIn}`}>
                <Icon icon="close" />
              </div>
            )}

            {!showRemove && !justUploaded && (
              <div
                onClick={(e) => removeFile(e, i)}
                className={`${classes.removeBtn} ${classes.closeOut}`}
              >
                <Icon icon="close" />
              </div>
            )}
            <p className={classes.itemName}>{f.name}</p>
          </Nav.Item>
        ))}
      </Nav>
    </div>
  );
};

export default DocsNav;